import { ReactElement, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import { useUIState } from '../../../../app/App';
import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { getDayAndMonth } from '../../../../utils/getDayAndMonth';

type Interface = { date: number | Date; className: string };

const Component = ({ date, className }: Interface): ReactElement => {
	const ref = useRef<HTMLDivElement>(null);
	const intl = useIntl();
	const { dateDelimiterStore } = useUIState();

	useEffect(() => {
		if (ref.current) {
			dateDelimiterStore.addDateDelimiter(ref.current);
			const nodeStyle = window.getComputedStyle(ref.current);
			const delimiterPaddingTop = nodeStyle.getPropertyValue('padding-top');
			dateDelimiterStore.setStaticDelimiterPaddingTop(parseFloat(delimiterPaddingTop));
		}
	}, [dateDelimiterStore]);
	return (
		<div>
			<div ref={ref} className={className}>
				{getDayAndMonth(date, intl)}
			</div>
		</div>
	);
};

const DateDelimiter = styled(Component)(
	({
		theme: {
			chat: { dateDelimiter },
		},
	}: {
		theme: Theme;
	}) => dateDelimiter
);

export { DateDelimiter };
